<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-row>
      <v-col
        cols="12"
        lg="6"
      >
        <base-material-chart-card
          :data="dailySalesChart.data"
          :options="dailySalesChart.options"
          color="success"
          hover-reveal
          type="Line"
        >
          <h4 class="card-title font-weight-light mt-2 ml-2">
            {{ $t('daily_sales') }}
          </h4>
        </base-material-chart-card>
      </v-col>
      <v-col
        cols="12"
        lg="6"
      >
        <base-material-chart-card
          :data="dailySalesChart.data"
          :options="dailySalesChart.options"
          color="success"
          hover-reveal
          type="Line"
        >
          <h4 class="card-title font-weight-light mt-2 ml-2">
            {{ $t('daily_sales') }}
          </h4>
        </base-material-chart-card>
      </v-col>
      <v-col
        cols="12"
        sm="6"
        lg="3"
      >
        <base-material-stats-card
          color="info"
          icon="fad fa-users fa-3x"
          :title="$t('users')"
          :value="usersCount"
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        lg="3"
      >
        <base-material-stats-card
          color="primary"
          icon="fad fa-boxes fa-3x"
          :title="$t('products')"
          :value="productsCount"
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        lg="3"
      >
        <base-material-stats-card
          color="success"
          icon="fad fa-bullhorn fa-3x"
          :title="$t('blog')"
          :value="blogCount"
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        lg="3"
      >
        <base-material-stats-card
          color="orange"
          icon="fad fa-ticket fa-3x"
          :title="$t('tickets')"
          :value="ticketsCount"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'DashboardDashboard',
    data () {
      return {
        dailySalesChart: {
          data: {
            labels: ['M', 'T', 'W', 'T', 'F', 'S', 'S'],
            series: [
              [12, 17, 7, 17, 23, 18, 38],
            ],
          },
          options: {
            lineSmooth: this.$chartist.Interpolation.cardinal({
              tension: 0,
            }),
            low: 0,
            high: 50, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
            chartPadding: {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
            },
          },
        },
        usersCount: '0',
        productsCount: '0',
        blogCount: '0',
        ticketsCount: '0',
      }
    },
    async created () {
      await this.getDashboardValues()
    },
    methods: {
      getDashboardValues () {
        this.$http.post('reports/dashboardValues').then(
          response => {
            this.usersCount = response.data.UsersCount.toString()
            this.productsCount = response.data.ProductsCount.toString()
            this.blogCount = response.data.BlogCount.toString()
            this.ticketsCount = response.data.TicketsCount.toString()
          },
          error => {
            if (error.data.code === 2001) {
              this.$router.push('/login')
            } else {
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ' | 0x915'
              this.snackbar = true
            }
          }).catch(error => {
          if (error) {
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ' | 0x916'
            this.snackbar = true
          }
        })
      },
    },
  }
</script>
